import { SignUpSuccessResponse, SignUpUserData } from './types'

export abstract class UserSignupRepository {
  abstract signup(
    data: SignUpUserData,
    langCode: string,
  ): Promise<SignUpSuccessResponse>
}
